import GLightbox from 'glightbox';
import tippy from 'tippy.js';
import axios from "axios";

export default class Home {
    constructor() {
        if (document.getElementById('pageProduct') !== null) {
            this.initImages();
            this.initGroups();
            this.initShopping();
            this.initTabs();
            this.initMoreFeatures();
            this.initIframes();
            this.initQuestion();
        }
    }

    initImages() {
        const imagesContainer = document.getElementById('imagesContainer');
        const imageList = JSON.parse(imagesContainer.dataset.images);
        const imageMainContainer = document.getElementById('imageMainContainer');
        const imageThumbContainer = document.getElementById('imageThumbContainer');

        for (let image in imageList) {
            let normal = imageList[image].normal;
            let large = imageList[image].large;

            let imageElement = document.createElement('img');
            imageElement.setAttribute('src', normal);
            imageElement.setAttribute('alt', imagesContainer.dataset.alt);
            let thumbElement = imageElement.cloneNode(true);

            if (imageMainContainer.querySelectorAll('a.glightbox').length === 0) {
                imageElement.classList.add('show');
                thumbElement.classList.add('show');
            }

            let linkElement = document.createElement('a');
            linkElement.setAttribute('href', large);
            linkElement.classList.add('glightbox');
            linkElement.dataset.gallery = 'product';

            linkElement.appendChild(imageElement)

            imageMainContainer.appendChild(linkElement)

            if (imageList.length > 1) {
                imageThumbContainer.appendChild(thumbElement);

                thumbElement.addEventListener('click', e => {
                    imageMainContainer.querySelectorAll('img').forEach(image => {
                        image.classList.remove('show');
                    });
                    imageThumbContainer.querySelectorAll('img').forEach(thumb => {
                        thumb.classList.remove('show');
                    });
                    imageElement.classList.add('show');
                    imageElement.classList.add('show');
                    thumbElement.classList.add('show');
                });
            }
        }
        ;

        const lightbox = GLightbox();
    }

    initGroups() {
        const moreLink = document.querySelector('#groupContainer .more');
        if (moreLink) {
            const itemsContainer = document.querySelector('#groupContainer .items');
            moreLink.addEventListener('click', function () {
                itemsContainer.classList.add('expand');
                moreLink.style.display = 'none';
            });
        }
    }

    initShopping() {
        const pageProduct = document.getElementById('pageProduct');
        const variantData = JSON.parse(pageProduct.dataset.variants);
        const attributeContainer = document.getElementById('attributeContainer');
        const buttonContainer = document.getElementById('buttonContainer');
        const quantityInput = buttonContainer.querySelector('input');
        const button = document.getElementById('cartButton');
        const stockContainer = document.getElementById('stockContainer');

        if (attributeContainer) {
            const attributes = attributeContainer.querySelectorAll('.attribute');
            const attributeInputs = document.querySelectorAll('input[name^=attribute]');
            const priceSaleContainer = document.querySelector('#priceContainer .price-from');
            const priceContainer = document.querySelector('#priceContainer strong');

            attributes.forEach((attribute, i) => {
                let values = attribute.querySelectorAll('.value');
                let hiddenInput = attribute.querySelector('input');
                let selectedValue;

                values.forEach(value => {
                    value.addEventListener('click', e => {
                        let activeValues = [];

                        values.forEach(v => {
                            v.classList.remove('selected');
                        });

                        value.classList.add('selected');
                        hiddenInput.value = value.dataset.value;

                        selectedValue = parseInt(value.dataset.value);

                        variantData.forEach((variant, j) => {
                            let variantValues = variant.values;

                            if (variantValues.includes(selectedValue)) {
                                variantValues.forEach(value => {
                                    activeValues.push(value);
                                });
                            }
                        });

                        let proceed = true;
                        attributes.forEach((attribute, j) => {
                            if(j > 0 && i != j) {
                                let values = attribute.querySelectorAll('.value');
                                values.forEach(v => {
                                    v.classList.remove('disabled');
                                    v.classList.remove('selected');

                                    if (!activeValues.includes(parseInt(v.dataset.value))) {
                                        v.classList.add('disabled');
                                        proceed = false;
                                    }
                                });
                            }
                        });

                        if(proceed){
                            this.setVariant(attributeInputs, variantData, button, priceSaleContainer, priceContainer, quantityInput, stockContainer);
                        }
                    });

                });
            });


            const event = document.createEvent('HTMLEvents');
            event.initEvent('click', true, false);
            attributes[0].querySelector('.value').dispatchEvent(event);
        }

        quantityInput.addEventListener('blur', e => {
            if (!quantityInput.value || Number.parseInt(quantityInput.value) === 0) {
                quantityInput.value = 1;
            }
        });

        quantityInput.addEventListener('keyup', e => {
            let reorderable = quantityInput.dataset.reorderable;
            let stock = quantityInput.dataset.stock;
            let value = quantityInput.value;

            if (Number.parseInt(quantityInput.value) === 0) {
                quantityInput.value = 1;
            }

            if (stock > 0) {
                if (reorderable === 'false' && value > stock) {
                    quantityInput.value = stock;
                    stockContainer.innerHTML = '<div class="availability in-stock"><i></i> <span>Nog ' + stock + ' stuk' + (stock > 1 ? 's' : '') + ' direct leverbaar</span></div>';
                } else if (value > stock) {
                    stockContainer.innerHTML = '<div class="availability in-stock"><i></i> <span>' + stock + ' stuk' + (stock > 1 ? 's' : '') + ' direct leverbaar</span></div>' +
                        '<div class="availability out-of-stock"><i></i> <span>' + (value - stock) + ' stuk' + ((value - stock) > 1 ? 's' : '') + ' leverbaar in 5-7 werkdagen</span></div>';
                } else {
                    stockContainer.innerHTML = '<div class="availability in-stock"><i></i> <span>Op voorraad</span></div>';
                }
            }
        });
    }

    setVariant(attributeInputs, variantData, button, priceSaleContainer, priceContainer, quantityInput, stockContainer) {
        let currentValues = []
        attributeInputs.forEach(input => {
            currentValues.push(parseInt(input.value));
        });

        variantData.forEach((variant, j) => {
            let variantValues = variant.values;

            if (JSON.stringify(variantValues.sort()) === JSON.stringify(currentValues.sort())) {
                // set variant id
                button.dataset.variantId = variant.variant_id;

                // set price
                if (variant.price_sale) {
                    priceSaleContainer.innerText = variant.price;
                    priceSaleContainer.classList.remove('d-none');
                    priceContainer.innerText = variant.price_sale;
                } else {
                    priceSaleContainer.classList.add('d-none');
                    priceContainer.innerText = variant.price;
                }

                // set stock
                button.disabled = false;
                quantityInput.disabled = false;
                quantityInput.value = 1;
                quantityInput.dataset.stock = variant.stock;
                quantityInput.dataset.reorderable = variant.reorderable;
                button.innerHTML = '<i class="icon-shopping-basket"></i> ' + button.dataset.addToCart;

                if (variant.stock > 0) {
                    stockContainer.innerHTML = '<div class="availability in-stock"><i></i> <span>' + stockContainer.dataset.inStock + '</span></div>';
                } else {
                    stockContainer.classList.add('out-of-stock');
                    stockContainer.classList.remove('in-stock');

                    if (variant.reorderable) {
                        stockContainer.innerHTML = '<div class="availability out-of-stock"><i></i> <span>' + stockContainer.dataset.deliveryTime + '</span></div>';
                    } else {
                        button.innerHTML = button.dataset.notOrderable;
                        button.disabled = true;
                        quantityInput.value = 0;
                        quantityInput.disabled = true;

                        stockContainer.innerHTML = '<div class="availability out-of-stock"><i></i> <span>' + stockContainer.dataset.inOrder + '</span></div>';
                    }
                }
            } else {
                // console.log('combi bestaat niet');
            }
        });
    }

    initTabs() {
        const tabContainer = document.getElementById('tabContainer');
        const accordeonItems = document.querySelectorAll('.tab');
        const tabContents = document.querySelectorAll('.tab-content');

        accordeonItems.forEach(item => {
            item.addEventListener('click', e => {
                tabContents.forEach(el => {
                    el.classList.remove('show');
                });

                if (item.classList.contains('show')) {
                    item.classList.remove('show');
                    tabContainer.scrollIntoView();
                } else {
                    accordeonItems.forEach(el => {
                        el.classList.remove('show');
                    });
                    item.classList.add('show');
                    item.scrollIntoView();
                }
            });

            if (window.innerWidth >= 576) {
                accordeonItems.forEach(el => {
                    el.classList.remove('show');
                });
            }
        });

        const listItems = document.querySelectorAll('ul.tabs li');
        listItems.forEach(li => {
            li.addEventListener('click', e => {
                listItems.forEach(li => {
                    li.classList.remove('active');
                });
                tabContents.forEach(el => {
                    el.classList.remove('show');
                });
                li.classList.add('active');

                let tabContent = document.getElementById(li.dataset.target);
                tabContent.classList.add('show');
            });
        });

        // if (window.innerWidth < 576) {
        //     tabContents[0].classList.remove('show');
        // }

        let startWidth = window.innerWidth;
        let resizeTimer;
        window.addEventListener('resize', e => {
            if (resizeTimer) clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {

                if (window.innerWidth >= 576) {
                    accordeonItems.forEach(el => {
                        el.classList.remove('show');
                    });

                    if (startWidth < 576) {
                        listItems[0].classList.add('active');
                        tabContents[0].classList.add('show');
                    }
                } else {
                    accordeonItems.forEach(el => {
                        el.classList.remove('show');
                    });
                    listItems.forEach(li => {
                        li.classList.remove('active');
                    });
                    tabContents.forEach(el => {
                        el.classList.remove('show');
                    });
                    accordeonItems[0].classList.add('show');
                }

                startWidth = window.innerWidth;
            }, 100, e);
        });
    }

    initMoreFeatures() {
        const link = document.querySelector('#featuresContainer a');
        const tab = document.querySelector('ul.tabs li[data-target=tabFeatures]');
        const tabContent = document.getElementById('tabFeatures');
        const listItems = document.querySelectorAll('ul.tabs li');
        const tabContents = document.querySelectorAll('.tab-content');

        if (link) {
            link.addEventListener('click', e => {
                e.preventDefault();

                listItems.forEach(li => {
                    li.classList.remove('active');
                });

                tabContents.forEach(el => {
                    el.classList.remove('show');
                });

                tab.classList.add('active');
                tabContent.classList.add('show');

                tab.scrollIntoView();
            });
        }
    }

    initIframes() {
        const iframes = document.querySelectorAll('iframe');
        iframes.forEach(iframe => {
            let wrapper = document.createElement('div');
            wrapper.classList.add('iframe-wrapper');
            iframe.parentNode.insertBefore(wrapper, iframe);
            wrapper.appendChild(iframe);
        });
    }

    initQuestion() {
        const form = document.getElementById('questionForm');
        const questionProduct = document.getElementById('questionProduct');
        const questionName = document.getElementById('questionName');
        const questionEmail = document.getElementById('questionEmail');
        const questionMessage = document.getElementById('questionMessage');
        const button = document.getElementById('questionButton');

        form.addEventListener('submit', e => {
            e.preventDefault();

            let message = document.querySelector('.question-message');
            if (message) {
                message.remove();
            }

            let icon = button.querySelector('i');
            icon.classList.remove('icon-arrow-right');
            icon.classList.add('loader');

            axios({
                method: 'post',
                url: '/stel-een-vraag',
                data: {
                    product: questionProduct.value,
                    name: questionName.value,
                    email: questionEmail.value,
                    message: questionMessage.value,
                    'g-recaptcha-response': getReCaptchaV3Response('question_id')
                }
            })
                .then(response => { // success
                    if (response.data) {
                        let message = document.createElement('div');
                        message.classList.add('alert', 'alert-success', 'question-message');
                        message.innerText = 'Bedankt voor je bericht, we zullen zo snel mogelijk reageren!';
                        form.prepend(message);
                    }
                })
                .catch(error => {
                    let message = document.createElement('div');
                    message.classList.add('alert', 'alert-danger', 'question-message');

                    let errorArr = [];
                    let errors = Object.values(error.response.data.errors);
                    errors.forEach(error => {
                        errorArr.push(error[0]);
                    });

                    message.innerHTML = errorArr.join('<br>');
                    form.prepend(message);

                    refreshReCaptchaV3('question_id', 'question_action');
                })
                .then(function () { // always
                    icon.classList.remove('loader')
                    icon.classList.add('icon-arrow-right');
                    questionName.value = '';
                    questionEmail.value = '';
                    questionMessage.value = '';
                });
        });
    }
}
